/** ISO 3166-1 alpha-2 code, e.g. "GB". */
export function isCountryCode(cc: unknown): cc is string {
  return typeof cc === 'string' && /^[A-Z]{2}$/.test(cc);
}

/** "GB" → 🇬🇧 (a pair of regional indicator symbols); '' when unknown. */
export function flag(cc: string | null | undefined): string {
  if (!isCountryCode(cc)) return '';
  return String.fromCodePoint(...[...cc].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65));
}

/** "🇬🇧 SneakyOtter417", or just the name when the country is unknown. */
export function withFlag(name: string, cc: string | null | undefined): string {
  const f = flag(cc);
  return f ? `${f} ${name}` : name;
}
